import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column justify-space-between",
  style: {"height":"100%","width":"100%"}
}
const _hoisted_2 = {
  key: 0,
  class: "iconMAP pt-1",
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "68px",
  viewBox: "0 0 300 300"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "cardRight mt-4" }
const _hoisted_5 = { class: "card-category" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "cardRight" }
const _hoisted_8 = { class: "cardBottomTopology ml-4" }

import { computed } from 'vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
import CONSTANTIMGS from '@/constants/images';
import CONSTANTSVGS from '@/constants/svg';
import { COLOR } from '@/constants/colors';

/********************************
 ********** INTERFACES **********
 *******************************/
import { IMGS } from '@/interfaces/SmartLink/Imgs';



export default /*#__PURE__*/_defineComponent({
  __name: 'SingleCard',
  props: {
    icon        : { type: String, required: false },
    colorIcon   : { type: String, required: true },
    middleText  : { type: String, required: true },
    bottomText  : { type: String, required: true },
    isTopology  : { type: Boolean, default: false },
    typeItem    : { type: String, default: 'Camion' },
    heigth      : { type: Number, default: 180 },
},
  setup(__props) {

const props = __props;

const { t } = useI18n()

/********************************
 ********** CONSTANTES **********
 *******************************/


const CONST_IMG:IMGS = {
    "PMP-AP"            : CONSTANTSVGS.pmpap,
    "PMP-SM"            : CONSTANTSVGS.pmpsm,
    "AP Movil"          : CONSTANTSVGS.solarTrailer,
    "AP FIjo"           : CONSTANTSVGS.tower,
    "Pala"              : CONSTANTSVGS.showel,
    "Camion"            : CONSTANTSVGS.haultruck,
    "Perforadora"       : CONSTANTSVGS.driller,
    "Cargador Frontal"  : CONSTANTSVGS.frontLoader,
    "Pila Agua"         : CONSTANTSVGS.waterTruck,
    "LTE"               : CONSTANTIMGS.IMAGES.lte,
    "PTP"               : CONSTANTSVGS.ptp,
};

const finalImage    = computed( () => CONST_IMG[props.typeItem]);

const styles = computed(() => {
    return { 
        '--colorIcon': props.colorIcon ,
        '--colorTextIcon' : props.colorIcon === COLOR.yellow ? '#000000' : '#FFFFFF'
    }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    style: _normalizeStyle(styles.value),
    color: "bgtl",
    class: "statusCards timelineStyles text-left",
    height: __props.heigth
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "ma-0",
        style: _normalizeStyle(`height: ${__props.heigth}px !important;`)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_row, {
              class: "ma-0",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  class: "pa-0",
                  cols: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      height: __props.isTopology ? 80 : 60,
                      width: __props.isTopology ? 80 : 60,
                      class: "cardIcon text-center"
                    }, {
                      default: _withCtx(() => [
                        (__props.isTopology)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                              _createElementVNode("g", { innerHTML: finalImage.value }, null, 8, _hoisted_3)
                            ]))
                          : (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              class: "iconStyle",
                              icon: __props.icon,
                              size: "40"
                            }, null, 8, ["icon"]))
                      ]),
                      _: 1
                    }, 8, ["height", "width"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  class: "pa-0",
                  cols: "8"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_unref(t)('labels.equipment')), 1),
                        (!__props.isTopology)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "s"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_7, [
                      _createElementVNode("span", {
                        class: _normalizeClass(__props.isTopology ? 'cardTitleTopology' :'card-title')
                      }, _toDisplayString(__props.middleText), 3)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_sheet, { color: "transparent" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "pa-0 pt-4 pb-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_divider, {
                      thickness: "2",
                      class: "mx-1"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { class: "pa-1 pb-3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(__props.bottomText), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["style", "height"]))
}
}

})